// @version 1.7.0
// @updated 2026-10-20
// staff-vote.js — スタッフ人気投票（data-votelist / テーマブロック共通描画）
// Changelog:
// - 1.7.0: data-votelist-order=random（表示順ランダム。loadLive 再 mount でも同一順を維持）
// - 1.6.7: SP でモーダル閉鎖後にスクロール不能になる不具合を修正（body lock / blur）
// - 1.6.6: 未ログインはカードに「ログイン」1ボタンのみ（長文2ボタンで崩れないように）
// - 1.6.5: 表示時の posts 照合を削除。コーデリンクは候補の post_id（保存時に書く）のみ
// - 1.6.3: 投票済み判定をフォローより先に。投票不可は disabled 見た目＋クリック可
// - 1.0.0: 初版

(function () {
  'use strict';

  var bodyScrollLockY = null;
  var bodyScrollLockCount = 0;

  function lockBodyScroll() {
    bodyScrollLockCount += 1;
    if (bodyScrollLockCount > 1) return;
    bodyScrollLockY = window.scrollY || window.pageYOffset || 0;
    document.documentElement.classList.add('staff-vote-scroll-lock');
    document.body.style.top = '-' + bodyScrollLockY + 'px';
  }

  function unlockBodyScroll() {
    if (bodyScrollLockCount < 1) return;
    bodyScrollLockCount -= 1;
    if (bodyScrollLockCount > 0) return;
    var y = bodyScrollLockY || 0;
    bodyScrollLockY = null;
    document.documentElement.classList.remove('staff-vote-scroll-lock');
    document.body.style.top = '';
    window.scrollTo(0, y);
  }

  function blurActive() {
    var el = document.activeElement;
    if (el && el !== document.body && typeof el.blur === 'function') el.blur();
  }

  function bufToHex(buf) {
    return Array.from(new Uint8Array(buf))
      .map(function (b) {
        return b.toString(16).padStart(2, '0');
      })
      .join('');
  }

  function sha256HexUtf8(str) {
    return crypto.subtle.digest('SHA-256', new TextEncoder().encode(str)).then(bufToHex);
  }

  function signWithDerivedKey(canonicalStr, derivedKeyHex) {
    var enc = new TextEncoder();
    return crypto.subtle
      .importKey('raw', enc.encode(derivedKeyHex), { name: 'HMAC', hash: 'SHA-256' }, false, ['sign'])
      .then(function (key) {
        return crypto.subtle.sign('HMAC', key, enc.encode(canonicalStr));
      })
      .then(bufToHex);
  }

  function canonicalForAuth(p) {
    function esc(s) {
      return String(s || '')
        .replace(/\\/g, '\\\\')
        .replace(/"/g, '\\"');
    }
    return (
      '{"content_sha256":"' +
      esc(p.content_sha256) +
      '","customer_id":"' +
      esc(String(p.customer_id)) +
      '","time_window":' +
      Number(p.time_window) +
      '}'
    );
  }

  function escapeHtml(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function parseJson(raw) {
    if (!raw) return null;
    if (typeof raw === 'object') return raw;
    try {
      return JSON.parse(raw);
    } catch (_e) {
      return null;
    }
  }

  function StaffVote(boot, root) {
    this.settings = (boot && boot.settings) || {};
    this.campaign = boot && boot.campaign;
    this.votedMap = parseJson(boot && boot.voted) || {};
    this.liveById = {};
    this.busy = false;
    this.root = root || document.querySelector('[data-staff-vote]');
    this.sessionKey = 'staff-vote:' + ((this.campaign && this.campaign.handle) || '');
    this.randomOrderByEl = typeof WeakMap !== 'undefined' ? new WeakMap() : null;
  }

  StaffVote.prototype.websiteId = function () {
    return (this.campaign && this.campaign.website_id) || this.settings.website_id || '';
  };

  StaffVote.prototype.candidates = function () {
    var list = (this.campaign && this.campaign.candidates) || [];
    if (typeof list === 'string') {
      try {
        list = JSON.parse(list);
      } catch (_e) {
        list = [];
      }
    }
    return Array.isArray(list) ? list : [];
  };

  StaffVote.prototype.votedIds = function () {
    var handle = this.campaign && this.campaign.handle;
    var node = (handle && this.votedMap[handle]) || this.votedMap;
    var ids = (node && (node.voted_staffs || node.votedStaffs)) || [];
    if (!Array.isArray(ids)) ids = [];
    try {
      var raw = sessionStorage.getItem(this.sessionKey);
      if (raw) {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) ids = parsed;
      }
    } catch (_e) {}
    return ids.map(String);
  };

  StaffVote.prototype.setVotedIds = function (ids) {
    ids = (ids || []).map(String);
    var handle = this.campaign && this.campaign.handle;
    if (handle) {
      this.votedMap[handle] = { voted_staffs: ids, page_count: ids.length };
    }
    try {
      sessionStorage.setItem(this.sessionKey, JSON.stringify(ids));
    } catch (_e) {}
  };

  StaffVote.prototype.hasFollowedAny = function () {
    var self = this;
    return this.candidates().some(function (c) {
      var live = self.liveById[c.id] || {};
      return !!(live.user_action && live.user_action.followed);
    });
  };

  StaffVote.prototype.isFollowed = function (id) {
    var live = this.liveById[id] || {};
    return !!(live.user_action && live.user_action.followed);
  };

  StaffVote.prototype.canVoteStaff = function (id) {
    if (!this.settings.customer_id) return false;
    var rule = (this.campaign && this.campaign.follow_rule) || 'per_staff';
    if (rule === 'any_one') return this.hasFollowedAny();
    return this.isFollowed(id);
  };

  StaffVote.prototype.limitOk = function (nextIds) {
    var limit = Number(this.campaign && this.campaign.vote_limit) || 0;
    if (!limit) return true;
    var scope = (this.campaign && this.campaign.vote_scope) || 'total';
    if (scope === 'per_brand') {
      var counts = {};
      var byId = {};
      this.candidates().forEach(function (c) {
        byId[String(c.id)] = c;
      });
      for (var i = 0; i < nextIds.length; i++) {
        var row = byId[nextIds[i]] || {};
        var key = row.brand_code || row.brand_id || '_';
        counts[key] = (counts[key] || 0) + 1;
        if (counts[key] > limit) return false;
      }
      return true;
    }
    return nextIds.length <= limit;
  };

  StaffVote.prototype.periodClosed = function () {
    if (!this.campaign) return true;
    if (this.campaign.status === 'closed') return true;
    var end = String(this.campaign.period_end || '').trim();
    if (!end) return false;
    var t = Date.parse(end.replace(/-/g, '/'));
    if (!t) return false;
    return Date.now() > t;
  };

  function brandKey(s) {
    return String(s || '')
      .trim()
      .toLowerCase()
      .replace(/[\s._\-]/g, '');
  }

  function addBrandToken(tokens, v) {
    var k = brandKey(v);
    if (k && tokens.indexOf(k) < 0) tokens.push(k);
  }

  function candidateBrandKeys(c, live) {
    var tokens = [];
    addBrandToken(tokens, c && c.brand_code);
    addBrandToken(tokens, c && c.brand_name);
    addBrandToken(tokens, c && c.brand_id);
    ((c && c.brands) || []).forEach(function (b) {
      if (!b) return;
      addBrandToken(tokens, b.code);
      addBrandToken(tokens, b.name);
      addBrandToken(tokens, b.id);
    });
    var liveObj = live || {};
    var st = liveObj.staff || {};
    var brands = st.brands || liveObj.brands || [];
    brands.forEach(function (b) {
      if (!b) return;
      addBrandToken(tokens, b.code);
      addBrandToken(tokens, b.name);
      addBrandToken(tokens, b.id);
    });
    return tokens;
  }

  StaffVote.prototype.filteredCandidates = function (brand, order) {
    var list = this.candidates().slice();
    var want = brandKey(brand);
    if (want && want !== 'all') {
      var self = this;
      list = list.filter(function (c) {
        var keys = candidateBrandKeys(c, self.liveById[String(c.id)]);
        return keys.indexOf(want) >= 0;
      });
    }
    if (order === 'vote_count') {
      var rankedRaw = this.campaign.ranked_ids || [];
      if (typeof rankedRaw === 'string') {
        try {
          rankedRaw = JSON.parse(rankedRaw);
        } catch (_e) {
          rankedRaw = [];
        }
      }
      var ranked = (rankedRaw || []).map(String);
      var counts = this.campaign.vote_counts || {};
      if (typeof counts === 'string') {
        try {
          counts = JSON.parse(counts);
        } catch (_e2) {
          counts = {};
        }
      }
      list.sort(function (a, b2) {
        var ia = ranked.indexOf(String(a.id));
        var ib = ranked.indexOf(String(b2.id));
        if (ia >= 0 && ib >= 0 && ia !== ib) return ia - ib;
        var ca = Number(counts[a.id] || 0);
        var cb = Number(counts[b2.id] || 0);
        if (cb !== ca) return cb - ca;
        return 0;
      });
    }
    return list;
  };

  /** Fisher–Yates。同一 [data-votelist] の再 mount では初回の並びを再利用 */
  StaffVote.prototype.applyRandomOrder = function (el, list) {
    var out = list.slice();
    var cached = null;
    if (el && this.randomOrderByEl) {
      cached = this.randomOrderByEl.get(el) || null;
    }
    if (cached && cached.length) {
      var byId = {};
      out.forEach(function (c) {
        byId[String(c.id)] = c;
      });
      var ordered = [];
      cached.forEach(function (id) {
        if (byId[id]) {
          ordered.push(byId[id]);
          delete byId[id];
        }
      });
      Object.keys(byId).forEach(function (id) {
        ordered.push(byId[id]);
      });
      return ordered;
    }
    var i;
    var j;
    var tmp;
    for (i = out.length - 1; i > 0; i -= 1) {
      j = Math.floor(Math.random() * (i + 1));
      tmp = out[i];
      out[i] = out[j];
      out[j] = tmp;
    }
    if (el && this.randomOrderByEl) {
      this.randomOrderByEl.set(
        el,
        out.map(function (c) {
          return String(c.id);
        })
      );
    }
    return out;
  };

  StaffVote.prototype.cardHtml = function (cand) {
    var id = String(cand.id);
    var live = this.liveById[id] || {};
    var name = live.name || cand.name || '';
    var img = cand.image_url || '';
    var shop = '';
    if (live.staff && live.staff.shops && live.staff.shops[0]) shop = live.staff.shops[0].name;
    if (!shop) shop = cand.shop_name || '';
    var followed = this.isFollowed(id);
    var currentVotes = this.votedIds();
    var voted = currentVotes.indexOf(id) >= 0;
    var loggedIn = !!this.settings.customer_id;
    var closed = this.periodClosed();
    var overwrite = this.campaign && this.campaign.allow_overwrite !== false;
    var canAct = false;
    if (loggedIn && !closed) {
      if (voted) {
        canAct = overwrite;
      } else if (this.canVoteStaff(id)) {
        if (!(currentVotes.length && !overwrite) && this.limitOk(currentVotes.concat([id]))) {
          canAct = true;
        }
      }
    }
    /* HTML disabled は click 不可。見た目だけ .disabled、期間終了のみ本当に disabled */
    var voteHardDisabled = closed;
    var voteSoftDisabled = !canAct && !closed;
    var followLabel = followed ? 'フォロー中' : 'フォロー';
    var voteLabel = voted ? '投票済み' : '投票';
    var loginUrl = this.settings.login_url || '/account/login';
    /* /pages/coordinate?id= は候補保存時の post_id（LEEEP post.id）。なければリンクなし */
    var coordId = String(cand.post_id || '').trim();
    var mediaHtml = img ? '<img src="' + escapeHtml(img) + '" alt="' + escapeHtml(name) + '">' : '';
    var mediaBlock = coordId
      ? '<a class="staff-vote-card__media" href="/pages/coordinate?id=' +
        encodeURIComponent(coordId) +
        '">' +
        mediaHtml +
        '</a>'
      : '<div class="staff-vote-card__media">' + mediaHtml + '</div>';
    var actionsHtml;
    if (!loggedIn) {
      actionsHtml =
        '<div class="staff-vote-card__actions staff-vote-card__actions--guest">' +
        '<a class="btn" href="' +
        escapeHtml(loginUrl) +
        '">ログイン</a>' +
        '</div>';
    } else {
      actionsHtml =
        '<div class="staff-vote-card__actions">' +
        '<button type="button" class="btn staff-vote-follow' +
        (followed ? ' btn--static is-followed' : ' btn--secondary') +
        '" data-follow="' +
        escapeHtml(id) +
        '">' +
        followLabel +
        '</button>' +
        '<button type="button" class="btn staff-vote-vote' +
        (voted ? ' is-voted' : '') +
        (voteSoftDisabled ? ' disabled' : '') +
        '"' +
        (voteHardDisabled ? ' disabled aria-disabled="true"' : voteSoftDisabled ? ' aria-disabled="true"' : '') +
        ' data-vote="' +
        escapeHtml(id) +
        '">' +
        voteLabel +
        '</button>' +
        '</div>';
    }
    return (
      '<article class="staff-vote-card" data-staff-id="' +
      escapeHtml(id) +
      '">' +
      mediaBlock +
      '<p class="staff-vote-card__name">' +
      escapeHtml(name) +
      '</p>' +
      '<p class="staff-vote-card__shop">' +
      escapeHtml(shop) +
      '</p>' +
      actionsHtml +
      '</article>'
    );
  };

  StaffVote.prototype.mountOne = function (el) {
    var brand = el.getAttribute('data-votelist-brand') || '';
    var order = el.getAttribute('data-votelist-order') || 'campaign_order';
    var sortKey = order === 'random' ? 'campaign_order' : order;
    var list = this.filteredCandidates(brand, sortKey);
    if (order === 'random') {
      list = this.applyRandomOrder(el, list);
    }
    if (!list.length) {
      el.innerHTML = '<p class="staff-vote-empty">表示できるスタッフがいません。</p>';
      return;
    }
    el.innerHTML =
      '<div class="staff-vote-grid">' +
      list
        .map(
          function (c) {
            return this.cardHtml(c);
          }.bind(this)
        )
        .join('') +
      '</div>';
  };

  StaffVote.prototype.mountAll = function () {
    var self = this;
    document.querySelectorAll('[data-votelist]').forEach(function (el) {
      var override = el.getAttribute('data-votelist-campaign') || '';
      if (override && self.campaign && override !== self.campaign.handle) return;
      self.mountOne(el);
    });
  };

  StaffVote.prototype.leeepUrl = function (path, params) {
    var base = String(this.settings.leeep_base || 'https://cite.leeep.jp').replace(/\/$/, '');
    var usp = new URLSearchParams();
    Object.keys(params || {}).forEach(function (k) {
      if (params[k] !== '' && params[k] != null) usp.set(k, params[k]);
    });
    return base + path + '?' + usp.toString();
  };

  StaffVote.prototype.loadLive = async function () {
    var ids = this.candidates().map(function (c) {
      return c.id;
    });
    if (!ids.length) return;
    var params = {
      website_id: this.websiteId(),
      staff_id: ids.join(','),
      count: 120,
      with_brand: 'true',
      with_shop: 'true',
      sort: 'selected_user_id'
    };
    if (this.settings.customer_id) params.user_id = this.settings.customer_id;
    var res = await fetch(this.leeepUrl('/v3/staffs', params));
    if (!res.ok) throw new Error('LEEEP HTTP ' + res.status);
    var data = await res.json();
    var list = data.staffs || [];
    var map = {};
    list.forEach(function (s) {
      map[String(s.id)] = s;
    });
    this.liveById = map;
  };

  StaffVote.prototype.feedbackModal = function () {
    var id =
      (this.settings && this.settings.feedback_modal_id) ||
      (this.root && this.root.getAttribute('data-feedback-modal-id')) ||
      '';
    if (!id) return null;
    var sel = '[data-modal="' + id + '"]';
    if (this.root) {
      var inRoot = this.root.querySelector(sel);
      if (inRoot) return inRoot;
    }
    return document.querySelector(sel);
  };

  StaffVote.prototype.closeFeedbackModal = function () {
    var modal = this.feedbackModal();
    if (!modal) return;
    blurActive();
    modal.classList.add('hide');
    modal.classList.remove('staff-vote-feedback--error');
    if (modal.dataset.svScrollLocked === '1') {
      modal.dataset.svScrollLocked = '';
      unlockBodyScroll();
    }
  };

  StaffVote.prototype.wireFeedbackModal = function () {
    var modal = this.feedbackModal();
    if (!modal || modal.dataset.svFeedbackWired === '1') return;
    modal.dataset.svFeedbackWired = '1';
    /* 親の overflow / stacking で隠れないよう body 直下へ */
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    var self = this;
    modal.querySelectorAll('.__close, .staff-vote-feedback-ok').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
        self.closeFeedbackModal();
      });
    });
  };

  StaffVote.prototype.setMsg = function (text, isError) {
    var trimmed = text != null ? String(text).trim() : '';
    var modal = this.feedbackModal();
    if (!modal) return;
    this.wireFeedbackModal();
    modal = this.feedbackModal();
    if (!modal) return;
    if (!trimmed) {
      this.closeFeedbackModal();
      return;
    }
    var bodyEl = modal.querySelector('[data-sv-modal-message]');
    var titleEl = modal.querySelector('header b');
    if (bodyEl) bodyEl.textContent = trimmed;
    if (titleEl) titleEl.textContent = isError ? 'ERROR' : 'MESSAGE';
    modal.classList.toggle('staff-vote-feedback--error', !!isError);
    if (modal.dataset.svScrollLocked !== '1') {
      modal.dataset.svScrollLocked = '1';
      lockBodyScroll();
    }
    modal.classList.remove('hide');
    var ok = modal.querySelector('.staff-vote-feedback-ok');
    var focusTarget = ok || modal.querySelector('header button.__close');
    if (focusTarget && typeof focusTarget.focus === 'function') {
      window.requestAnimationFrame(function () {
        focusTarget.focus();
      });
    }
  };

  StaffVote.prototype.follow = async function (id) {
    if (!this.settings.customer_id) return;
    var followed = this.isFollowed(id);
    var path = '/v3/staffs/' + encodeURIComponent(id) + (followed ? '/unfollow' : '/follow');
    var res = await fetch(String(this.settings.leeep_base || 'https://cite.leeep.jp').replace(/\/$/, '') + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ website_id: this.websiteId(), user_id: String(this.settings.customer_id) })
    });
    if (!res.ok) throw new Error('フォローに失敗しました');
    if (!this.liveById[id]) this.liveById[id] = {};
    if (!this.liveById[id].user_action) this.liveById[id].user_action = {};
    this.liveById[id].user_action.followed = !followed;
    this.mountAll();
  };

  StaffVote.prototype.vote = async function (id) {
    if (this.periodClosed()) {
      this.setMsg('投票受付期間は終了しました', true);
      return;
    }
    if (!this.settings.customer_id) return;
    var overwrite = this.campaign && this.campaign.allow_overwrite !== false;
    var current = this.votedIds().slice();
    var idx = current.indexOf(String(id));
    var next;
    /* 投票済み／上限をフォロー判定より先に（誤って「フォローすると…」が出ないように） */
    if (idx >= 0) {
      if (!overwrite) {
        this.setMsg('このキャンペーンは再投票できません', true);
        return;
      }
      next = current.filter(function (x) {
        return x !== String(id);
      });
    } else {
      if (current.length && !overwrite) {
        this.setMsg('すでに投票済みです', true);
        return;
      }
      next = current.concat([String(id)]);
      if (!this.limitOk(next)) {
        this.setMsg('投票上限に達しています', true);
        return;
      }
    }
    if (!this.canVoteStaff(id)) {
      this.setMsg('フォローすると投票できます', true);
      return;
    }
    var answers = {};
    var adding = next.indexOf(String(id)) >= 0;
    if (adding && this.questions().length) {
      answers = await this.askQuestions();
      if (!answers) return;
    }
    await this.postBallot(next, answers);
    this.setVotedIds(next);
    this.mountAll();
    this.setMsg(next.indexOf(String(id)) >= 0 ? '投票を受け付けました' : '投票を取り消しました');
  };

  StaffVote.prototype.questions = function () {
    var raw = this.campaign && this.campaign.questions;
    if (typeof raw === 'string') raw = parseJson(raw);
    if (!Array.isArray(raw)) return [];
    return raw.filter(function (q) {
      return q && String(q.label || q.key || '').trim();
    });
  };

  StaffVote.prototype.questionKey = function (q, i) {
    var k = String((q && q.key) || '').trim();
    if (k) return k;
    k = String((q && q.label) || '')
      .trim()
      .toLowerCase()
      .replace(/[^\w]+/g, '-')
      .replace(/^-|-$/g, '');
    return k || 'q' + (i + 1);
  };

  StaffVote.prototype.askQuestions = function () {
    var self = this;
    var questions = this.questions();
    return new Promise(function (resolve) {
      var prev = document.querySelector('.staff-vote-modal');
      if (prev) {
        blurActive();
        prev.remove();
        unlockBodyScroll();
      }
      var overlay = document.createElement('div');
      overlay.className = 'staff-vote-modal';
      overlay.setAttribute('role', 'dialog');
      overlay.setAttribute('aria-modal', 'true');
      var fields = questions
        .map(function (q, i) {
          var key = self.questionKey(q, i);
          var req = q.required ? ' <span class="staff-vote-modal__req">必須</span>' : '';
          var type = q.type || 'text';
          var opts = Array.isArray(q.options) ? q.options : [];
          var keyAttr = ' name="' + escapeHtml(key) + '" data-q-key="' + escapeHtml(key) + '"';
          var inner = '';
          if (type === 'textarea') {
            inner = '<textarea' + keyAttr + ' rows="3"></textarea>';
          } else if (type === 'select') {
            inner =
              '<select' +
              keyAttr +
              '><option value="">選択してください</option>' +
              opts
                .map(function (o) {
                  var val = typeof o === 'string' ? o : o.value || o.label || '';
                  var lab = typeof o === 'string' ? o : o.label || o.value || '';
                  return '<option value="' + escapeHtml(val) + '">' + escapeHtml(lab) + '</option>';
                })
                .join('') +
              '</select>';
          } else if (type === 'radio' || type === 'checkbox') {
            inner = opts
              .map(function (o) {
                var val = typeof o === 'string' ? o : o.value || o.label || '';
                var lab = typeof o === 'string' ? o : o.label || o.value || '';
                var inpType = type === 'checkbox' ? 'checkbox' : 'radio';
                return (
                  '<label class="staff-vote-modal__choice"><input type="' +
                  inpType +
                  '"' +
                  keyAttr +
                  ' value="' +
                  escapeHtml(val) +
                  '"> ' +
                  escapeHtml(lab) +
                  '</label>'
                );
              })
              .join('');
          } else {
            inner = '<input type="text"' + keyAttr + '>';
          }
          return (
            '<label class="staff-vote-modal__field">' +
            '<span class="staff-vote-modal__label">' +
            escapeHtml(q.label || key) +
            req +
            '</span>' +
            inner +
            '</label>'
          );
        })
        .join('');
      overlay.innerHTML =
        '<div class="staff-vote-modal__panel">' +
        '<h2 class="staff-vote-modal__title">投票の確認</h2>' +
        '<form class="staff-vote-modal__form">' +
        fields +
        '<p class="staff-vote-modal__err" data-sv-q-err hidden></p>' +
        '<div class="staff-vote-modal__actions">' +
        '<button type="button" class="btn staff-vote-modal__cancel">キャンセル</button>' +
        '<button type="submit" class="btn">投票する</button>' +
        '</div></form></div>';
      document.body.appendChild(overlay);
      lockBodyScroll();
      function close(result) {
        document.removeEventListener('keydown', onKey);
        blurActive();
        overlay.remove();
        unlockBodyScroll();
        resolve(result);
      }
      function onKey(e) {
        if (e.key === 'Escape') close(null);
      }
      document.addEventListener('keydown', onKey);
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay) close(null);
      });
      overlay.querySelector('.staff-vote-modal__cancel').addEventListener('click', function () {
        close(null);
      });
      overlay.querySelector('form').addEventListener('submit', function (e) {
        e.preventDefault();
        var err = overlay.querySelector('[data-sv-q-err]');
        err.hidden = true;
        var answers = {};
        for (var i = 0; i < questions.length; i++) {
          var q = questions[i];
          var key = self.questionKey(q, i);
          var type = q.type || 'text';
          var val = '';
          var nodes = overlay.querySelectorAll('[data-q-key="' + key.replace(/"/g, '\\"') + '"]');
          if (type === 'checkbox') {
            val = Array.prototype.map
              .call(nodes, function (el) {
                return el.checked ? el.value : '';
              })
              .filter(Boolean)
              .join(', ');
          } else if (type === 'radio') {
            var picked = Array.prototype.filter.call(nodes, function (el) {
              return el.checked;
            })[0];
            val = picked ? picked.value : '';
          } else {
            val = nodes[0] ? String(nodes[0].value || '').trim() : '';
          }
          if (q.required && !val) {
            err.hidden = false;
            err.textContent = (q.label || key) + 'は必須です';
            return;
          }
          answers[key] = val;
        }
        close(answers);
      });
      var first = overlay.querySelector('input, textarea, select');
      if (first) first.focus();
    });
  };

  StaffVote.prototype.postBallot = async function (staffIds, answers) {
    var endpoint = String(this.settings.webhook_endpoint || '').trim();
    var derivedKey = String(this.settings.derived_key || '').trim();
    var customerId = String(this.settings.customer_id || '').trim();
    var timeWindow = this.settings.time_window;
    if (!endpoint) throw new Error('Webhook endpoint が未設定です');
    if (!derivedKey || !customerId || timeWindow == null || timeWindow === '') {
      throw new Error('署名キーがありません。ログインと secret を確認してください');
    }
    var payload = {
      action: 'staff_vote_request',
      campaign_handle: this.campaign.handle,
      staff_ids: staffIds,
      answers: answers || {}
    };
    var contentObj = {
      action: payload.action,
      campaign_handle: payload.campaign_handle,
      staff_ids: staffIds,
      answers: payload.answers
    };
    payload.content_json = JSON.stringify(contentObj);
    payload.content_sha256 = await sha256HexUtf8(payload.content_json);
    payload.customer_id = customerId;
    payload.time_window = Number(timeWindow);
    payload.signature = await signWithDerivedKey(canonicalForAuth(payload), derivedKey);
    var res = await fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    if (!res.ok && res.status !== 204) {
      var body = '';
      try {
        body = await res.text();
      } catch (_e) {}
      throw new Error('HTTP ' + res.status + (body ? ': ' + body.slice(0, 180) : ''));
    }
  };

  StaffVote.prototype.bind = function () {
    var self = this;
    if (this._bound) return;
    this._bound = true;
    this.wireFeedbackModal();
    document.addEventListener('click', function (e) {
      var followBtn = e.target.closest('[data-follow]');
      var voteBtn = e.target.closest('[data-vote]');
      if (!followBtn && !voteBtn) return;
      e.preventDefault();
      if (voteBtn && voteBtn.disabled && !voteBtn.classList.contains('disabled')) {
        if (self.periodClosed()) self.setMsg('投票受付期間は終了しました', true);
        return;
      }
      if (self.busy) return;
      self.busy = true;
      var p = followBtn
        ? self.follow(followBtn.getAttribute('data-follow'))
        : self.vote(voteBtn.getAttribute('data-vote'));
      p.catch(function (err) {
        self.setMsg(err && err.message ? err.message : String(err), true);
      }).finally(function () {
        self.busy = false;
      });
    });
  };

  StaffVote.prototype.start = async function () {
    if (!this.campaign) return;
    this.bind();
    this.mountAll();
    try {
      await this.loadLive();
      this.mountAll();
    } catch (err) {
      this.setMsg('スタッフ情報の取得に失敗しました: ' + (err && err.message ? err.message : err), true);
    }
  };

  function boot() {
    var root = document.querySelector('[data-staff-vote]');
    if (!root) return;
    var node = root.querySelector('script[type="application/json"]');
    if (!node) return;
    var data = {};
    try {
      data = JSON.parse(node.textContent || '{}');
    } catch (_e) {
      return;
    }
    var app = new StaffVote(data, root);
    app.start();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
